export enum NotificationType {
  DEPOSER_DEVIS = 'DEPOSER_DEVIS',
  RAPPELER_RDV = 'RAPPELER_RDV',
  DEPOTS_PIECES_ADMINISTRATIVES = 'DEPOTS_PIECES_ADMINISTRATIVES',
  PLANIFIER_RDV = 'PLANIFIER_RDV',
  PRENDRE_CONNAISSANCE_AUDIT = 'PRENDRE_CONNAISSANCE_AUDIT',
  CONFIRMATION_SELECTION_SCENARIO = 'CONFIRMATION_SELECTION_SCENARIO',
  CHANTIER_CONFORME = 'CHANTIER_CONFORME',
}

export interface NotificationItem {
  id: string;
  transactionId?: string;
  userId: string;
  title: string;
  description: string;
  type: NotificationType;
  read: boolean;
  createdAt: string;
  updatedAt: string;
  date: string;
  redirectUrl?: string;
}
